/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Dropdown from 'DesignSystem/Dropdown/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/ImportFromDevices/Content/ModalBody/Sources/Content"
  
}) {
let dwtSourcesValueData = fromData.useDataValue({ viewPath,
context: 'dwt',
path: 'sources',
})
let dwtCurrentSourceValueData = fromData.useDataValue({ viewPath,
context: 'dwt',
path: 'currentSource',
})
let dwtOnSourceChangeValueData = fromData.useDataValue({ viewPath,
context: 'dwt',
path: 'onSourceChange',
})
  return (<React.Fragment
>
<Dropdown
  viewPath={`${viewPath}/Dropdown`}
 data="dwt.sources"
 from={dwtSourcesValueData}
 data="dwt.currentSource"
 selected={dwtCurrentSourceValueData}
 data="dwt.onSourceChange"
 onClick={dwtOnSourceChangeValueData}
 label={false}
 text="Select a device"
 field="name"
 maxWidth={310}
 width={310}
 top={34}
/>
{children}
</React.Fragment>)
}